import {formatNumber, getCurrencySymbol} from '@angular/common';
import {Pipe, PipeTransform} from "@angular/core";

/**
 * Euros:

 Display as €12,000

 Pounds:

 Display as £20,100

 US Dollars:

 Display as US $7,200

 AUS Dollars:

 Display as AU $400,000

 Canadian Dollars:

 Display as CAD 34,500

 New Zealand Dollars:

 Display as NZ $200,000
 * @param currencyCode
 * @param locale
 */
export function getCurrencyCodeAndSymbol(currencyCode: string, locale = 'en-US'): string {
  const theCurrencyCode = (currencyCode ? currencyCode : 'USD').toUpperCase();
  const theSymbolOnly = getCurrencySymbol(theCurrencyCode, 'narrow', locale);
  const theSymbolAndCurrency = getCurrencySymbol(theCurrencyCode, 'wide', locale);
  if (theCurrencyCode === 'NZD' || theCurrencyCode === 'MXN') {
    const symbolPrefix = theSymbolAndCurrency.substr(0, theSymbolAndCurrency.indexOf(theSymbolOnly));
    return symbolPrefix ? `${symbolPrefix} ${theSymbolOnly}` : theSymbolOnly;
  }
  if ( theCurrencyCode === 'USD') {
    return `US ${theSymbolOnly}`;
  }
  if (currencyCode === 'AUD') {
    return `AU ${theSymbolOnly}`;
  }
  if (currencyCode === 'CAD') {
    return 'CAD';
  }
  if (currencyCode === 'JPY') {
    return 'JPY';
  }
  return theSymbolOnly;
}

export function currencyFormatting(value: any, currencyCode: string, digitsInfo: string, locale = 'en-US'): string {
  if (value == null) {
    return '';
  }
  const theCurrencyCode = currencyCode ? currencyCode : 'USD';
  let theCurrencyCodeAndSymbol = getCurrencyCodeAndSymbol(theCurrencyCode, locale);
  if (theCurrencyCode === 'CAD' || theCurrencyCode === 'JPY') {
    theCurrencyCodeAndSymbol = `${theCurrencyCodeAndSymbol} `;
  }
  return `${theCurrencyCodeAndSymbol}${formatNumber(value, locale, digitsInfo)}`;
}

@Pipe({name: 'marsCurrency'})
export class MarsCurrencyPipe implements PipeTransform {
  transform(value: any, currencyCode: string, digitInfo: string, locale: string = 'en-US'): string {
    return currencyFormatting(value, currencyCode, digitInfo, locale);
  }
}
